import axios from 'axios';
export default class PackageService {
    async getPackagelist(data) {
        return await axios .post('api/v1/admin/package/list', data);
    }
    // async addNotice(title, description, create_date) {
    //     return await axios
    //         .post(`api/v1/admin/notice/add`, {
    //             title: title,
    //             description: description,
    //             create_date: create_date,
    //         })
    //         .then((res) => res);
    // }
    async viewPackage(ids) {
        return await axios
            .post(`api/v1/admin/package/details`, {
                package_id: ids,
            })
            .then((res) => res.data);
    }
    async editPackage(data) {
        return await axios
            .post(`api/v1/admin/package/edit`, data)
            .then((res) => res);
    }
    async GetAddTypeList(data) {
        return await axios
            .post(`api/v1/admin/package/ad-type/list`, data)
            .then((res) => res);
    }
    async GetAddSubTypeList(ad_type_id) {
        return await axios
            .post(`api/v1/admin/package/ad-sub-type/list`,{ad_type_id:ad_type_id})
            .then((res) => res);
    }
    async GetUpgleTypeList(data) {
        return await axios
            .post(`api/v1/admin/package/upgle/list`,data)
            .then((res) => res);
    }
    async GetTalentTypeList(data) {
        return await axios
            .post(`api/v1/admin/package/talent_search/list`,data)
            .then((res) => res);
    }
}
